import { useState } from "react"
import { icons } from "./icons"
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { atomDark } from 'react-syntax-highlighter/dist/esm/styles/prism';



const Export = ({bgColor,bgMesh}) => {

    const [open,setOpen] = useState(false)

    const printCode = () => {
      let b = bgMesh;
      b = b.split('  ').join(' ').split(', ').join(',').split(' ,').join(',')
      return 'background-color:'+bgColor+';\nbackground-image:\n'+bgMesh.split(',radial-gradient').join(',\nradial-gradient')+';'
      
    }

    const cnt = open ? <div className='grid grid-cols-12 fixed inset-0 z-50 bg-slate-900 px-10'>
      <div className='absolute top-0 cursor-pointer right-0 p-10' onClick={()=>setOpen(false)}>{icons.close}</div>
      <div className='col-span-6 flex flex-col m-10 bg-red-200 rounded-xl overflow-hidden'>
        <div className='flex flex-1 bg-mute-200 items-end overflow-hidden'>
          <div className='relative h-60 w-full'>
            <img className='shadow-md min-w-[319px] h-[740px] -mt-[370px] -ml-[220px] absolute top-2/4 left-2/4 z-10' src='./img/hero4.png' alt='CSS Hero' />
            <img className='shadow-xl min-w-[319px] h-[780px] -mt-[390px] -ml-[100px] absolute top-2/4 left-2/4 z-20' src='./img/hero2.png' alt='CSS Hero' />
          </div>
        </div>
        <div className='flex flex-1 bg-mute-100 items-center max-h-[300px]'>

          <div className='mx-20'>
              <h2 className='font-bold text-2xl mb-3 text-slate-800'>Want to use it with WordPress?</h2>
              <p className='text-base text-slate-600'>Learn how CSS Hero can easily help you embedding this (and many other) CSS snippet into your WordPress project with a simple point and click interface.</p>
              <div className='flex mt-5'>
                <a className=' p-3 px-5 cursor-pointer rounded-xl bg-accent text-white text-xs font-bold' href='//www.csshero.org/?rid=39626' target='_blank'>Discover CSS Hero &rarr;</a>
              </div>
            </div>

        </div>
      </div>
      <div className='col-span-6 flex items-center justify-center'>
        <div className='text-base max-w-full flex flex-col flex-1 p-10'>
          <div className='h-80 mb-10 bg-pink-800 rounded-xl shadow-mini' style={{backgroundColor:bgColor,backgroundImage:bgMesh}}></div>
          <SyntaxHighlighter wrapLongLines={true} language="css" style={atomDark}>
            {printCode()}
          </SyntaxHighlighter>
          <div className='flex justify-end pt-3'>
              <div className='p-3 px-5 cursor-pointer rounded-xl bg-slate-600 text-white text-xs font-bold' onClick={()=>{
            navigator.clipboard.writeText(printCode())
          }}>Copy to clipboard</div>
          </div>
        </div>
      </div>
    </div> : []

  

   return <><div onClick={()=>setOpen(!open)} className="flex relative cursor-pointer p-3 gap-3 rounded-xl font-bold bg-accent text-white icons-white items-center">Export
        {icons.code}
      </div>
      {cnt}
      </>

}

export default Export